/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthResponseAdminTokenDto } from '../../models/auth-response-admin-token-dto';

export interface AdminAuthControllerGetTokenNameV1$Params {
}

export function adminAuthControllerGetTokenNameV1(http: HttpClient, rootUrl: string, params?: AdminAuthControllerGetTokenNameV1$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResponseAdminTokenDto>> {
  const rb = new RequestBuilder(rootUrl, adminAuthControllerGetTokenNameV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthResponseAdminTokenDto>;
    })
  );
}

adminAuthControllerGetTokenNameV1.PATH = '/v1/admin/auth/token';
